module.exports = ":host .logo img {\n  height: 5em; }\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/hospital-booking/header/header.component.scss
// module id = 1253
// module chunks = 0